import { api } from './client';
import { stringifyParams } from '@/lib/utils';
import type { ApiResponse } from '@/types/api';
import type {
  ShopList,
  ShopCustomerGroupParameters,
  CustomerGroup
} from '@/types/shop';

/**
 * 비밀번호 재설정 요청
 * @param credentials 비밀번호 재설정 정보 (이메일)
 * @param platform 플랫폼
 * @returns Promise<ApiResponse<ResetPasswordResponse>> 비밀번호 재설정 응답
 */
export async function getShopList(): Promise<ApiResponse<ShopList[]>> {
  return api.get<ShopList[]>(`/shop/shop`);
}

/**
 * 임직원 등급 조회
 * @returns 
 */
export async function getShopCustomerGroup(params: ShopCustomerGroupParameters): Promise<ApiResponse<CustomerGroup[]>> {
  const stringParams = stringifyParams(params);
  return api.get<CustomerGroup[]>(`/shop/customer-group`, { params: stringParams });
}